
import { callIfMobile, ltTabletDevice, onlyDevice } from '../lib/core/responsive';
import { Component, Vue } from 'vue-property-decorator';
import { Actions, ActionStates } from '../lib/Actions';
import { container } from '../lib/container';
import { ContainerTypes } from '../lib/core/types/ContainerTypes';
import { MutationTypes } from '../store/mutation-types';

@Component
export default class NavBar extends Vue {
	headerNavClass: Array<string> = [];
	burgerIcon = 'menu';
	navItems = [
		{
			path: '/filialfinder/home',
			title: 'Home',
			icon: 'home'
		},
		{
			path: '/filialfinder/search',
			title: 'Geldautomatensuche',
			icon: '\uE926'
		},
		{
			path: '/contact',
			title: 'Kontakt der Cashpool-Banken',
			icon: 'contacts'
		},
		{
			path: '/copyright',
			title: 'Datenschutz',
			icon: 'security'
		},
		{
			path: '/impressum',
			title: 'Impressum',
			icon: 'info'
		}
	];

	get isSearchBarVisible(): boolean {
		return this.$store.getters.isSearchVisible;
	}

	get isNotAppView(): boolean {
		const { isAppView } = this.$store.state;
		return !isAppView;
	}

	get showSearchBarToggle(): boolean {
		const { isAppView } = this.$store.state;
		const { onFilialfinder } = this.$store.getters;
		const isMobile = ltTabletDevice();

		return isAppView && onFilialfinder && isMobile;
	}

	toggleSearchBar(): void {
		this.$store.commit(MutationTypes.toggleSearchBar);
	}

	toggle(array: Array<string>, item: string): void {
		if (array.includes(item)) {
			array.splice(array.indexOf(item), 1);
		} else {
			array.push(item);
		}
	}

	navToggle() {
		callIfMobile(() => {
			this.toggle(this.headerNavClass, 'header__nav--open');

			this.burgerIcon = this.burgerIcon == 'menu' ? 'close' : 'menu';

			// add class for app container
			const appElement = document.getElementById('app');
			appElement?.classList.toggle('app__header--open');
		});
	}

	mounted() {
		// route to search route, when searching something
		const actions = container.get<Actions>(ContainerTypes.Action);
		actions.on(ActionStates.SearchInput, () => {
			if (this.$router.currentRoute.path != '/filialfinder/search') {
				this.$router.push('/filialfinder/search');
			}
		});
	}
}
